import { cn } from '@/lib/utils';

import BadgeSB from '@/components/atoms/badge/BadgeSB';
import Button from '@/components/atoms/button';
import { HeaderItemLevel } from '@/components/atoms/layout/header/HeaderSB';
import MobileHeaderItemListSB from '@/components/atoms/layout/header/MobileHeaderItemListSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import IconChevronRight from '~/svg/IconChevronRight.svg';

interface MobileHeaderItemSBProps {
  menuLevel: HeaderItemLevel<any>;
}

export type MobileHeaderItemSBExternalProps = {
  containerRef: React.MutableRefObject<HTMLDivElement | null>;
  selectedMenu: string;
  currentIndex: string;
  onClick: () => void;
  onMenuSelect: (value: string) => void;
  currentTitle: React.ReactNode;
  parentTitle?: React.ReactNode;
};

export default function MobileHeaderItemSB({
  block,
  ...rest
}: BlockComponentModel<MobileHeaderItemSBProps> &
  MobileHeaderItemSBExternalProps) {
  const { menuLevel } = block;
  const {
    onClick,
    containerRef,
    selectedMenu,
    onMenuSelect,
    currentIndex,
    currentTitle,
    parentTitle,
  } = rest;

  function handleMenuClick() {
    onClick();
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const menuLevels = menuLevel?.secondLevels || menuLevel?.thirdLevels || [];

  return (
    <div>
      <Button
        classNames={{
          root: 'p-0 text-neutral-N40 h-auto w-full justify-start font-sans group',
          inner: 'flex justify-between w-full text-neutral-N00',
        }}
        variant='text'
        onClick={handleMenuClick}
      >
        <div className={cn('flex w-full items-center justify-between')}>
          <div className='flex items-center gap-2'>
            <p className='text-wrap text-left'>{menuLevel.title}</p>
            {menuLevel.badge && (
              <BadgeSB
                block={menuLevel.badge}
                inner={{ size: 's', variant: 'outlined' }}
              />
            )}
          </div>
          <IconChevronRight />
        </div>
      </Button>
      <div className={cn('flex w-full flex-col gap-9')}>
        <MobileHeaderItemListSB
          block={{
            menuLevel: menuLevels,
            level: menuLevel.level,
          }}
          containerRef={containerRef}
          selectedMenu={selectedMenu}
          onMenuSelect={onMenuSelect}
          currentIndex={currentIndex}
          currentTitle={currentTitle}
          parentTitle={parentTitle}
        />
      </div>
    </div>
  );
}
